import React from 'react';
import {ContainerPadding, ContainerSize, ContainerVariant} from './container.types';

interface ContainerProps {
  background?: string;
  children: React.ReactNode;
  className?: string;
  padding?: ContainerPadding;
  size?: ContainerSize;
  variant?: ContainerVariant;
}

const sizeClasses: Record<ContainerSize, string> = {
  [ContainerSize.SM]: 'max-w-xl',
  [ContainerSize.MD]: 'max-w-2xl',
};

export const Container: React.FC<ContainerProps> = ({
  background = '',
  children,
  className = '',
  padding = ContainerPadding.MD,
  size = ContainerSize.MD,
  variant = ContainerVariant.Centered,
}) => {
  const paddingClass = padding === ContainerPadding.MD ? 'p-4 sm:p-6 md:p-8' : 'p-2 sm:p-4';
  const centeredClass = variant === ContainerVariant.Centered ? 'mx-auto' : '';
  const formClass = variant === ContainerVariant.Form ? 'flex flex-col min-h-screen' : '';

  return (
    <div className={`w-full ${sizeClasses[size]} ${paddingClass} ${centeredClass} ${formClass} ${background} ${className}`.trim()}>
      {children}
    </div>
  );
};
